import { render } from "./ProgramTrackListView.vue?vue&type=template&id=3453f9df&ts=true"
import script from "./ProgramTrackListView.vue?vue&type=script&lang=ts"
export * from "./ProgramTrackListView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__